// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.category-setting-label[data-v-0d179f50] {\n    padding-bottom: 8px;\n    font-weight: bold;\n    font-size: 14px;\n}\n.category-textarea[data-v-0d179f50] {\n    font-size: 14px;\n    background-color: #F3F3F3;\n}\n[data-v-0d179f50]::-moz-placeholder {\n    color: #BBBBBB;\n}\n[data-v-0d179f50]:-ms-input-placeholder {\n    color: #BBBBBB;\n}\n[data-v-0d179f50]::placeholder {\n    color: #BBBBBB;\n}\n\n", ""]);
// Exports
module.exports = exports;
